import main from './catalog.svg';
import active from './catalog-filled.svg';
import disabled from './catalog-gestalt.svg';

export default { main, active, disabled };
